import _slicedToArray from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react'; // modified from https://usehooks.com/useDebounce/

/**
 * @internal Intended for internal use - use it on your own risk
 */

export function useDebouncePair(first, second, delay) {
  var _useState = useState([first, second]),
      _useState2 = _slicedToArray(_useState, 2),
      debouncedValue = _useState2[0],
      setDebouncedValue = _useState2[1];

  useEffect(function () {
    // Update debounced value after delay
    var handler = setTimeout(function () {
      setDebouncedValue([first, second]);
    }, delay); // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed ...
    // .. within the delay period. Timeout gets cleared and restarted.

    return function () {
      clearTimeout(handler);
    };
  }, [first, second, delay]);
  return debouncedValue;
}